export default __webpack_public_path__ + "static/media/employeetype-icon.a699c861.svg";